import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=bb914136&scoped=true&"
import script from "./horizontal-nav.vue?vue&type=script&lang=js&"
export * from "./horizontal-nav.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-nav.vue?vue&type=style&index=0&id=bb914136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb914136",
  null
  
)

component.options.__file = "horizontal-nav.vue"
export default component.exports